import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as lightboxAccessibility from './scripts/lightbox-accessibility';
lightboxAccessibility.init();

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as cardTeaserSlider from './scripts/card-teaser-slider';
cardTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();

import * as weatherSlider from './scripts/weather-slider';
weatherSlider.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({ addUrlParams: true });

import * as parallax from "./scripts/parallax";
parallax.init();

import * as circleAnimation from './scripts/circle-animation';
circleAnimation.init();

import * as weatherArchive from './scripts/weather-archive';
weatherArchive.init();

import * as multiselectDropdown from './scripts/multiselect-dropdown';
multiselectDropdown.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as setDatepickerRange from './scripts/set-datepicker-range';
setDatepickerRange.init();

import * as datepickerRange from '@elements/datepicker-range';
datepickerRange.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();

import 'bootstrap/js/dist/dropdown';



